import React from 'react';
import moment from "moment";
import {CONTACT_US, LANDING} from "../../constants/routes";
import './styles.css';

/**
 * Footer component.
 */
export const Footer = () => {
    return (
        <div>
            <hr style={{marginTop: 20, marginBottom: 20, border: 0}} />
            <footer className="footer">
                <div className="container">
                    <div className="text-center"><a href={LANDING}>About Us</a> | <a href={CONTACT_US}>Contact Us</a></div>
                    <div className="text-center">&copy; Copyright {moment().format('YYYY')}, {'AutoI™'}</div>
                </div>
            </footer>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/footer/Footer.jsx